import React, { FC } from 'react'

import * as SC from './styled'

export type TitleDescriptionProps = {
  className?: string
  title?: string
  imageDescription?: string
  description?: string
  image?: {
    src: string
    alt?: string
  }
  isCentered?: boolean
}

const TitleDescription: FC<TitleDescriptionProps> = (props) => {
  const { className, title, imageDescription, description, image, isCentered } = props

  return (
    <SC.Container className={className} $isCentered={isCentered}>
      {title && <SC.Title>{title}</SC.Title>}
      {image && <SC.Image src={image.src} alt={image.alt} />}
      {imageDescription && (
        <SC.ImageDescription dangerouslySetInnerHTML={{ __html: imageDescription }} />
      )}
      {description && <SC.Description dangerouslySetInnerHTML={{ __html: description }} />}
    </SC.Container>
  )
}

export default TitleDescription
